"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

require("./ContentBox.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Content box with padding and underlined title */
function ContentBox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      underline = _ref.underline;
  var contentBoxClassName = (0, _utils.getClassNames)('Content-box', {
    'content-box_title': underline
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: contentBoxClassName
  }, children);
}

ContentBox.propTypes = {
  /** Additional class to block */
  className: _propTypes.default.string,

  /** @ignore */
  children: _propTypes.default.node,

  /** Underline after title */
  underline: _propTypes.default.bool
};
ContentBox.defaultProps = {
  className: null,
  children: null,
  underline: true
};
var _default = ContentBox;
exports.default = _default;